// extracted by mini-css-extract-plugin
export var container = "_fb-0";
export var outlet = "_fb-1";
export var outletEnter = "_fb-2";
export var outletEnterActive = "_fb-3";
export var outletExit = "_fb-4";
export var outletExitActive = "_fb-5";